export const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN || 'https://server.tps-lao.com';
export const API_BASE_URL = `${API_ORIGIN}/api`;
export const DEFAULT_BRAND_LOGO = '/favicon.ico';

export const apiUrl = (path = '') => {
  if (path.startsWith('http')) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export function normalizeAssetUrl(urlOrPath = '') {
  if (!urlOrPath) {
    return '';
  }

  if (urlOrPath.startsWith('http://') || urlOrPath.startsWith('https://')) {
    return urlOrPath.replace(/^https?:\/\/localhost:\d+/, API_ORIGIN);
  }

  const cleaned = urlOrPath.replace(/^\//, '');

  if (
    cleaned.startsWith('images/') ||
    cleaned.startsWith('static/') ||
    cleaned.startsWith('assets/')
  ) {
    return `/${cleaned}`;
  }

  const cleanedPath = cleaned.replace(/^ImageUpload\//, '');
  return `${API_ORIGIN}/ImageUpload/${cleanedPath}`;
}

export const assetUrl = (path = '') => {
  return normalizeAssetUrl(path);
};
